import React from 'react';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { makeStyles, TablePagination } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const createRows = (data) => {
  const rows = [];
  for (let i = 0; i < data.length; i++) {
    const row = {
      id: data[i]?.id || '',
      userId: data[i]?.userId || '',
      tcnCustomerId: data[i]?.tcnCustomerId || '',
      campaignId: data[i]?.campaignId || '',
      requestIp: data[i]?.requestIp || '',
      environment: data[i]?.environment || '',
      variant: data[i]?.variant || '',
      method: data[i]?.method || '',
      productId: data[i]?.productId || '',
      amount: data[i]?.amount || '',
      result: data[i]?.result || '',
      quantity: data[i]?.quantity || '',
      eoidType: data[i]?.eoidType || '',
      eoidValue: data[i]?.eoidValue || '',
      createdAt: data[i]?.createdAt || '',
      userEmail: data[i]?.user?.email || ''
    };

    rows.push(row);
  }
  return rows;
};

const AgentIssuanceTable = ({
  issuedCardLogs,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  totalRowCount,
  page
}) => {
  const classes = useStyles();
  const rows = issuedCardLogs?.length > 0 ? createRows(issuedCardLogs) : [];

  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer component={Paper} className="table-container">
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Id </TableCell>
                {/* <TableCell align="left">UserId </TableCell> */}
                <TableCell align="left">Email </TableCell>
                <TableCell align="left">TCNCustomerId </TableCell>
                <TableCell align="left">IpAddress</TableCell>
                <TableCell align="left">Environment</TableCell>
                <TableCell align="left">Method</TableCell>
                <TableCell align="left">CampaignId</TableCell>
                <TableCell align="left">ProductId</TableCell>
                <TableCell align="left">Amount</TableCell>
                <TableCell align="left">Quantity</TableCell>
                <TableCell align="left">Eoid Type</TableCell>
                <TableCell align="left">Eoid Value</TableCell>
                <TableCell align="left">Variant</TableCell>
                <TableCell align="left">Result</TableCell>
                <TableCell align="left">CreatedAt</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 ? (
                rows.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell align="left">{row.id}</TableCell>
                    {/* <TableCell align="left">{row.userId}</TableCell> */}
                    <TableCell align="left">{row.userEmail}</TableCell>
                    <TableCell align="left">{row.tcnCustomerId}</TableCell>
                    <TableCell align="left">{row.requestIp}</TableCell>
                    <TableCell align="left">{row.environment}</TableCell>
                    <TableCell align="left">{row.method}</TableCell>
                    <TableCell align="left">{row.campaignId}</TableCell>
                    <TableCell align="left">{row.productId}</TableCell>
                    <TableCell align="left">{row.amount}</TableCell>
                    <TableCell align="left">{row.quantity}</TableCell>
                    <TableCell align="left">{row.eoidType}</TableCell>
                    <TableCell align="left">{row.eoidValue}</TableCell>
                    <TableCell align="left">{row.variant}</TableCell>
                    <TableCell align="left">{row.result}</TableCell>
                    <TableCell align="left">
                      {row.createdAt
                        ? format(parseISO(row.createdAt), 'yyyy-MM-dd HH:mm:ss')
                        : '-'}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow style={{ height: 53 * 1 }}>
                  <TableCell colSpan={6}>
                    {' '}
                    No data available in table{' '}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={totalRowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
};

AgentIssuanceTable.propTypes = {
  issuedCardLogs: PropTypes.array,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  totalRowCount: PropTypes.number
};

export default AgentIssuanceTable;
